import React from 'react';
import { OrangeAccent } from './OrangeAccent';
interface VideoTestimonial {
  title: string;
  videoId: string;
}
const VIDEOS: VideoTestimonial[] = [{
  title: 'This Clinic Made $30K in 2 Weeks',
  videoId: 'Mnc13rLYLuA'
}, {
  title: '$117K to $144K in 30 Days',
  videoId: 'E2aHZD_Xbe8'
}, {
  title: "23-Year Chiropractor: I Wish I'd Done It Sooner",
  videoId: '4uJYnXQeH94'
}, {
  title: '15-Year Chiropractor Doubles Revenue in 30 Days',
  videoId: 'awnUEJsFyNY'
}];
export function ClientResults() {
  return <section id="results" className="w-full scroll-mt-20 py-16 md:py-20 px-4" data-id="element-35">
      <div className="max-w-[1100px] mx-auto" data-id="element-36">
        <h2 className="font-display font-extrabold text-ink text-center leading-[1.1]" style={{
        fontSize: 'clamp(28px, 4vw, 44px)',
        letterSpacing: '-.02em'
      }} data-id="element-37">
          Our Client <span className="text-orange" data-id="element-38">Results</span>
        </h2>
        <div className="flex justify-center mt-3 mb-12" data-id="element-39">
          <OrangeAccent data-id="element-40" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6" data-id="element-41">
          {VIDEOS.map(v => <div key={v.videoId} className="bg-white border border-line rounded-[16px] overflow-hidden" data-id="element-42">
              <div className="w-full aspect-video" data-id="element-43">
                <iframe src={`https://www.youtube.com/embed/${v.videoId}`} title={v.title} className="w-full h-full border-none" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-44" />
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}